import { Component, Input } from '@angular/core';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { ServiceTypeEnum } from '../../models/cartDetails/service-type.enum';
import { AppInjector } from '../../utils/services/set-app-injector';
import { PromotionTypeEnum } from '../../models/cartDetails/promotionType.model';

@Component({
  selector: 'order-details-slot-addon',
  templateUrl: './order-details-slot-addon.component.html',
})
export class OrderDetailsSlotAddonComponent {
  @Input() public addonIndex: number;
  @Input() public ordinalNumber: number;
  @Input() public serviceType: ServiceTypeEnum;
  @Input() public promotionType: PromotionTypeEnum;
  @Input() set addonData(addon: any) {
    this.addon = addon;
  }

  public addon: any = {};
  protected commonInfo: CommonInfoService = AppInjector.get(CommonInfoService);

  constructor() {
  }

  getStepAddonPrice(price: any): string {
    return price.price[this.commonInfo.taxName];
  }

  getMainAddonPrice(): string {
    return this.addon.priceInfos[0]?.prices[0]?.price[this.commonInfo.taxName] || '';
  }

  showPrice(): boolean {
    return this.addon.addonGroup !== 'obligatory' || this.addon.addonGroup === 'grouped';
  }

}
